import React from 'react'

const Manual_borrar_productos_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Borrar Productos Ecommerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo eliminar productos del catálogo de tu tienda online de forma rápida y segura.
        </p>
        <iframe
          src="https://scribehow.com/embed/Borrar_Productos_Ecommerce__4fiMWQAKQE-JPlcPvjC3Uw?as=scrollable"
          className="scribe-iframe-general-103"
          width="100%"
          height="2000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_borrar_productos_ecommerce
